import { render, staticRenderFns } from "./FooterLink.vue?vue&type=template&id=862e3be2&"
import script from "./FooterLink.vue?vue&type=script&lang=js&"
export * from "./FooterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports